export const PERMISSION_TOKEN_SET = 'PERMISSION_TOKEN_SET';
export const PERMISSION_ID_ASSOCIATE_TO_BOARD = 'PERMISSION_ID_ASSOCIATE_TO_BOARD';
export const BOARD_PERMISSION_LOAD = 'BOARD_PERMISSION_LOAD';
